export default __webpack_public_path__ + "static/media/gxsumstateus.f0b97a89.csv";